import { ConfluenceSoftwarePageProps } from "../../../pages/confluence/confluence-software-page";

import { ConfluenceSoftwarePage } from "./confluence-software-page";

export const ConfluenceSoftwarePageTemplate = (
    props: ConfluenceSoftwarePageProps
) => {
    const ConfluenceSoftwarePageComponent = ConfluenceSoftwarePage;

    return <ConfluenceSoftwarePageComponent {...props} />;
};
